import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelect, MatSelectModule } from "@angular/material/select";
import { BackOfficeOfferViewModel } from "@playcharge/common/models/backend/offers/backoffice/backoffice-offer-view-model";
import { OrderByPipe } from "../../../pipes/orderBy.pipe";
import { CopyOfferDataEditModel } from "@playcharge/common/models/backend/offers/backoffice/copy-offer-data-edit-model";

@Component({
    selector: "app-copy-offer-dialog",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        OrderByPipe,
    ],
    templateUrl: "./copy-offer-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyOfferDialogComponent {
    private _selfRef: MatDialogRef<CopyOfferDialogComponent> = inject(
        MatDialogRef<CopyOfferDialogComponent>,
    );

    public data: { sourceOfferId: number; offers: BackOfficeOfferViewModel[] } =
        inject(MAT_DIALOG_DATA);

    public form: FormGroup<{ offerId: FormControl<number> }> = new FormGroup<{
        offerId: FormControl<number>;
    }>({
        offerId: new FormControl<number>(null!, {
            nonNullable: true,
            validators: [Validators.required],
        }),
    });

    public close(): void {
        const data: CopyOfferDataEditModel = {
            offerId: this.form.getRawValue().offerId,
            sourceOfferId: this.data.sourceOfferId,
        };

        this._selfRef.close(data);
    }
}
